import { registerRoute } from '../router';
import { apiFetch } from '../api';
import { escapeHtml } from '../format';

interface ActivityEntry {
  type: 'login';
  userName: string;
  userRole: string;
  at: string;
}

interface DashboardStats {
  campaignsSentToday: number;
  messagesSentToday: number;
  deliveryRate: number | null;
  configuredProviders: number;
  recentActivity: ActivityEntry[];
}

function formatRelativeTime(iso: string): string {
  const diffMs = Date.now() - new Date(`${iso.replace(' ', 'T')}Z`).getTime();
  const minutes = Math.round(diffMs / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

function renderActivity(entries: ActivityEntry[]): string {
  if (entries.length === 0) {
    return `<p style="color:var(--clr-text-muted);font-size:0.9rem;">No activity yet.</p>`;
  }

  return `<ul style="display:flex;flex-direction:column;gap:10px;">
    ${entries
      .map(
        (entry) => `
      <li style="display:flex;align-items:center;justify-content:space-between;font-size:0.88rem;">
        <span>${escapeHtml(entry.userName)} signed in <span class="badge badge--muted">${escapeHtml(entry.userRole)}</span></span>
        <span style="color:var(--clr-text-dim);font-size:0.8rem;">${formatRelativeTime(entry.at)}</span>
      </li>`,
      )
      .join('')}
  </ul>`;
}

registerRoute({
  path: '/dashboard',
  title: 'Dashboard',
  render: ({ container }) => {
    container.innerHTML = `
      <div class="page-header">
        <h1>Dashboard</h1>
        <p>Overview of today's sending activity.</p>
      </div>
      <div class="stat-grid" id="dashboard-stats">
        <div class="card stat-card"><span class="stat-label">Campaigns sent today</span><span class="stat-value">…</span></div>
        <div class="card stat-card"><span class="stat-label">Messages sent today</span><span class="stat-value">…</span></div>
        <div class="card stat-card"><span class="stat-label">Delivery rate</span><span class="stat-value">…</span></div>
        <div class="card stat-card"><span class="stat-label">Configured providers</span><span class="stat-value">…</span></div>
      </div>
      <div class="card">
        <h2 style="font-size:1rem;margin-bottom:12px;">Recent activity</h2>
        <div id="dashboard-activity">Loading…</div>
      </div>
    `;

    apiFetch<DashboardStats>('/api/dashboard/stats')
      .then((stats) => {
        const grid = container.querySelector('#dashboard-stats')!;
        const values = grid.querySelectorAll('.stat-value');
        values[0]!.textContent = String(stats.campaignsSentToday);
        values[1]!.textContent = String(stats.messagesSentToday);
        values[2]!.textContent = stats.deliveryRate === null ? '—' : `${stats.deliveryRate}%`;
        values[3]!.textContent = String(stats.configuredProviders);

        container.querySelector('#dashboard-activity')!.innerHTML = renderActivity(stats.recentActivity);
      })
      .catch(() => {
        container.querySelector('#dashboard-activity')!.textContent = 'Could not load activity.';
      });
  },
});
